import mod from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bk-frame.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bk-frame.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./_common/components/bk-frame.vue?vue&type=script&lang=js
// module id = xzgW
// module chunks = 0